<template>
  <LibErrorBoundary component-name="DictionaryRichText">
    <LibRichTextRenderer
      v-if="renderDocument"
      v-bind="$attrs"
      class="rte-text"
      :rich-text="renderDocument"
    />
    <span v-else-if="fallback" v-bind="$attrs" class="rte-text">{{
      fallback
    }}</span>
  </LibErrorBoundary>
</template>

<script setup lang="ts">
import type { Document } from '@contentful/rich-text-types';
import { useRichTextDictionary } from '~/composables/useRichTextDictionary';

defineOptions({
  inheritAttrs: false
});

interface Props {
  dictionaryKey: string;
  fallback?: string;
  fallbackDocument?: Document;
}

const props = defineProps<Props>();

const richTextDictionary = useRichTextDictionary(
  computed(() => [props.dictionaryKey])
);

const richText = computed(() => richTextDictionary.value[props.dictionaryKey]);

const renderDocument = computed(() => richText.value ?? props.fallbackDocument);
</script>
